if (!customElements.get('hero-legacy')) {
  customElements.define(
    'hero-legacy',
    class HeroLegacy extends HTMLElement {
      constructor() {
        super();
      }

      get loop() {
        return this.dataset.loop.toLocaleLowerCase() === 'true';
      }

      get autoplay() {
        return this.dataset.autoplay.toLocaleLowerCase() === 'true';
      }

      get speed() {
        return Number(this.dataset.speed);
      }

      get delay() {
        return Number(this.dataset.speed);
      }

      get disabledDesktop() {
        return this.dataset.disabledDesktop.toLocaleLowerCase() === 'true';
      }

      connectedCallback() {
        this.createSlider();
      }

      createSlider() {
        const slider = this.querySelector(`.hero__slider-${this.id}`);
        const pagination = this.querySelector(`.hero__pagination-${this.id}`);
        const prevButton = this.querySelector(`.hero__prev-slide-${this.id}`);
        const nextButton = this.querySelector(`.hero__next-slide-${this.id}`);
        if (this.disabledDesktop && window.innerWidth >= 1024) return;
        let settings = {};
        if (this.autoplay) {
          settings = {
            slidesPerView: 1,
            loop: this.loop,
            speed: this.speed,
            autoplay: {
              delay: this.delay,
            },
            pagination: {
              el: pagination,
              clickable: true,
            },
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
          };
        } else {
          settings = {
            slidesPerView: 1,
            loop: this.loop,
            speed: this.speed,
            pagination: {
              el: pagination,
              clickable: true,
            },
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
          };
        }

        new Swiper(slider, settings);
      }
    },
  );
}
